/* eslint no-unused-vars: "off" */
import React, { useContext, useState } from 'react';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { NavigateToWindowWithNativeEvents } from '@components/_common/link/link';
import { useIntersectionObserver } from 'usehooks-ts';
import Card from '../_common/card/Card';
import {
  STCPromoCardWrapper,
  ContentWrapper,
  Content,
  Button,
  BoldTitle,
  TextContainer,
  PromoText,
  PromoSubText,
} from './STCPromoCard.styles';
import TradeCashIcon from '../../assets/TradeCashIcon';
import { AnalyticEvents } from '../../constants';

const STCPromoCard = ({ feedData, positionValue }: any) => {
  const { trackEvent } = useContext(AnalyticsContext) as any;
  const [cardPosition] = useState(positionValue || 0);
  const {
    id: cardId,
    title,
    callToAction: { title: buttonText, link },
    caption,
    content: {
      textArray: [subText],
    },
  } = feedData;

  const handleRedirect = () => {
    trackEvent(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });
    datadogRum.addAction(AnalyticEvents.ovpCardClicked, {
      cardId,
      cardPosition,
    });
    NavigateToWindowWithNativeEvents({
      url: link,
      event: 'get_your_offer',
    });
  };

  const captureImpression = () => {
    setTimeout(() => {
      trackEvent(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
      datadogRum.addAction(AnalyticEvents.viewedOvpCardImpression, {
        cardId,
        cardPosition,
      });
    }, 1000);
  };
  const { ref } = useIntersectionObserver({
    freezeOnceVisible: true,
    threshold: 0.5,
    onChange: (isIntersecting) => {
      if (isIntersecting && captureImpression) captureImpression();
    },
  });

  const header = {
    title: <BoldTitle>{title}</BoldTitle>,
  };

  return (
    <STCPromoCardWrapper ref={ref}>
      <Card dataQa="stc-promo" header={header} headerIcon={<TradeCashIcon />}>
        <ContentWrapper>
          <Content>
            <TextContainer>
              <PromoText data-testid="stc-promo-text">{caption}</PromoText>
              <PromoSubText data-testid="stc-promo-subtext">{subText}</PromoSubText>
            </TextContainer>
          </Content>
          <Button data-testid="stc-promo-cta-button" size="small" onClick={handleRedirect}>
            {buttonText}
          </Button>
        </ContentWrapper>
      </Card>
    </STCPromoCardWrapper>
  );
};

export default STCPromoCard;
